import React, { useState, useEffect, useRef } from 'react'
import api from '../components/api'
import JoditEditor from "jodit-react"



const Modal = (props) => {


    var inscricao_id = props.inscricao_id
    var tipo = props.tipo
    var tipoEmail = props.tipoEmail

    

    var [titulo, setTitulo] = useState('')
    var [texto, setTexto] = useState('')
    var [email, setEmail] = useState('')
    
    var [linkEvento, setLinkEvento] = useState('')
    var [emailGerado, setEmailGerado] = useState(false)
    
    var [lang, setLang] = useState('pt')
    var [nomeParticipante, setNomeParticipante] = useState('')
    var [nomeEvento, setNomeEvento] = useState('')
    var [evento_id, setEventoId] = useState()

    var [dataInicioEvento, setDataInicioEvento] = useState('')
    var [horaInicioEvento, setHoraInicioEvento] = useState('')
    var [horaTerminoEvento, setHoraTerminoEvento] = useState('')

    var [localEvento, setLocalEvento] = useState('')
    var [enderecoEvento, setEnderecoEvento] = useState('')
    

    //var [linkRecuperacaoSenha, setLinkRecuperacaoSenha] = useState()
    
    
    //var [autor, setAutor] = useState(sessionStorage.getItem('nome'))
    //var ad_usr = sessionStorage.getItem('us_codigo')


    const editor = useRef(null)
    const [content, setContent] = useState('')


    const [config, setConfig] = useState({
        readonly: false,
        toolbar: true,
        height: 300,
        placeholder: 'Escreva aqui...',
      })


    async function carrega() {

        
        if (!isNaN(inscricao_id)) {

            await api.get(`inscrito/${inscricao_id}`).then((result) => {

                //console.log(result.data[0])

                setEmail(result.data[0].email)
                setNomeParticipante(result.data[0].nomeParticipante)
                setNomeEvento(result.data[0].nome)
                //setTipo(result.data[0].tipo == 'O' ? 'on-line' : result.data[0].tipo == 'P' ? 'presencial' : '')
                //setTipo(result.data[0].tipo)
                setLinkEvento(result.data[0].linkEvento)
                setLang(result.data[0].lang)
                setEventoId(result.data[0].evento_id)
                setDataInicioEvento(result.data[0].data_inicio)
                setHoraInicioEvento(result.data[0].horaInicio)
                setHoraTerminoEvento(result.data[0].horaTermino)
                setLocalEvento(result.data[0].local)
                setEnderecoEvento(result.data[0].enderecoEvento)
                
                /*
                Sua inscrição está confirmada!
                Agradecemos o seu interesse em participar do evento <%=INCLUIR SE É on-line ou presencial%> <b><%=nome_evento%></b>.
                Consulte mais informações em: <%=INCLUIR LINK DA PÁGINA DO EVENTO%>	

                Em caso de dúvidas, entre em contato conosco (Incluir link do fale conosco no trecho "entre em contato conosco": https://www.hospitaissaudaveis.org/FaleConosco).

                Atenciosamente,
                Equipe do Projeto Hospitais Saudáveis
                */
               
                

    
            }).catch((err) => {
    
                console.log(err.response)
    
            })


        }


    }

    useEffect(() => {


        switch (lang) {


            case 'pt':


                if (tipoEmail == 'L') {

                    if (tipo == 'O') {

                        var txt = `

                        Prezado(a),<br><br>
                        Agradecemos a sua inscrição e interesse no evento on-line <b>${nomeEvento}</b>. Seguem as informações para participação. 
                        <br><br>
                        <br>
                        Link para ingressar no dia ${dataInicioEvento}, das ${horaInicioEvento} às ${horaTerminoEvento}: <br>
                        <b><a href='${linkEvento}'>${linkEvento}</a></b>
                                        
                        <br><br><br>

                        Consulte mais informações em: <a href="https://hospitaissaudaveis.org/Evento/${evento_id}">https://hospitaissaudaveis.org/Evento/${evento_id}</a><br><br>

                        Em caso de dúvidas, <a href='https://www.hospitaissaudaveis.org/FaleConosco'>entre em contato conosco</a>.<br>

                        <br><br>

                        Atenciosamente,<br>
                        <b><font color="black">Projeto Hospitais Saudáveis</font></b>
                        `

                        setTitulo('PHS | Acesso ao evento')

                    } else {

                        var txt = `

                        Prezado(a),<br><br>
                        Agradecemos a sua inscrição e interesse no evento <b>${nomeEvento}</b>. 
                        Seguem as informações para participação. 
                        <br><br>
                        
                        Aguardamos você no ${localEvento}, no dia ${dataInicioEvento}, das ${horaInicioEvento} às ${horaTerminoEvento}.
                                        
                        <br><br>

                        Endereço: ${enderecoEvento}
                        
                        <br><br><br>

                        Consulte mais informações em: <a href="https://hospitaissaudaveis.org/Evento/${evento_id}">https://hospitaissaudaveis.org/Evento/${evento_id}</a><br><br>

                        Em caso de dúvidas, <a href='https://www.hospitaissaudaveis.org/FaleConosco'>entre em contato conosco</a>.<br>

                        <br><br>

                        Atenciosamente,<br>
                        <b><font color="black">Projeto Hospitais Saudáveis</font></b>
                        `

                        setTitulo('PHS | Acesso ao evento')

                    }

                } else {

                    if (evento_id == '137') {

                        var txt = `
                
                        Sua inscrição está confirmada!<br><br><br>
                        
                        Agradecemos o seu interesse em participar do evento <b>17º Seminário Hospitais Saudáveis - SHS 2024</b> com o tema <b>"Resiliência e Adaptação Climática no Sistema de Saúde Brasileiro: um caminho para equidade e justiça social"</b>, que será realizado nos dias <b>29 e 30 de outubro de 2024</b> no <b>Mercure Barra da Tijuca</b>.<br><br>

                        Para reservar hospedagem com desconto no local do evento, acesse o site <a href="https://bupplus.com.br">https://bupplus.com.br</a>, selecione o Hotel Mercure Barra da Tijuca ou Ibis Barra da Tijuca e utilize o cupom promocional <b>PROJETC</b>.<br><br>
    
                        Consulte mais informações em: <a href="https://hospitaissaudaveis.org/Evento/${evento_id}">https://hospitaissaudaveis.org/Evento/${evento_id}</a><br><br>
    
                        Em caso de dúvidas, <a href='https://www.hospitaissaudaveis.org/FaleConosco'>entre em contato conosco</a>.<br>
    
                        <br><br>
    
                        Atenciosamente,<br>
                        <b><font color="black">Projeto Hospitais Saudáveis</font></b>
                        `

                    } else {

                        var txt = `
                
                        Sua inscrição está confirmada!<br><br><br>
                        
                        Agradecemos o seu interesse em participar do evento ${tipo == 'O' ? 'on-line' : 'presencial'} <b>${nomeEvento}</b>.<br><br>
    
                        Consulte mais informações em: <a href="https://hospitaissaudaveis.org/Evento/${evento_id}">https://hospitaissaudaveis.org/Evento/${evento_id}</a><br><br>
    
                        Em caso de dúvidas, <a href='https://www.hospitaissaudaveis.org/FaleConosco'>entre em contato conosco</a>.<br>
    
                        <br><br>
    
                        Atenciosamente,<br>
                        <b><font color="black">Projeto Hospitais Saudáveis</font></b>
                        `
                    }

                    setTitulo('PHS | Confirmação de Inscrição')

                }

                setContent(txt)
                setTexto(txt)
                

                break

            case 'es':


                var txt = `
                
                ¡Tu inscripción está confirmada!<br><br><br>
                
                Gracias por su interés en participar en el evento ${tipo == 'O' ? 'on-line' : 'presencial'} <b>${nomeEvento}</b>.<br><br>

                Vea aquí los detalles del evento: <a href="https://hospitaissaudaveis.org/Evento/${evento_id}">https://hospitaissaudaveis.org/Evento/${evento_id}</a><br><br>

                Ante cualquier duda, <a href='https://www.hospitaissaudaveis.org/FaleConosco'>por favor escríbanos</a>.<br><br><br>

                ¡Le esperamos!<br>
                <b><font color="black">Projecto Hospitales Saludables + Salud sin Daño</font></b>
                `

                setContent(txt)
                setTexto(txt)
                setTitulo('PHS | Confirmación de inscripción')

                break



            case 'en':


                var txt = `
                
                Your registration is confirmed!<br><br>
                
                Thank you for your interest in participating in the event ${tipo == 'O' ? 'on-line' : 'presencial'} <b>${nomeEvento}</b>.<br><br>

                See more details at: <a href="https://hospitaissaudaveis.org/Evento/${evento_id}">https://hospitaissaudaveis.org/Evento/${evento_id}</a><br><br>

                <a href='https://www.hospitaissaudaveis.org/FaleConosco'>Please send a message</a> if you have any questions.<br><br><br>

                Sincerely,<br>
                <b><font color="black">Healthy Hospitals Project + Health Care Without Harm</font></b>
                `

                setContent(txt)
                setTexto(txt)
                setTitulo('PHS | Registration confirmation')
                break


        } 



    }, [inscricao_id, tipo, evento_id, tipoEmail])


    function enviaMail() {


        if (titulo == '') {

            window.toastr.error('<b>T&iacute;tulo</b> não pode ficar em branco!')
            return false

        }

        if (email == '') {

            window.toastr.error('<b>E-mail</b> não pode ficar em branco!')
            return false

        }

        if (content == '') {

            window.toastr.error('<b>Texto</b> não pode ficar em branco!')
            return false

        }


        var dataPost = {

            inscricao_id: inscricao_id,
            titulo: titulo,
            texto: texto,
            email: email,
            tipoEmail: tipoEmail,

        }

        //console.log(dataPost)


        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma enviar o e-mail?',
		    buttons: {
		        Sim: function () {

                    //console.log(dataPost)
    
                    api.post('emailConfirmacaoEvento', dataPost).then((result) => {

                        //console.log(result.data)
                        window.$("#ModalEmailConfirmacao").modal('hide');
                        window.$("#modalInscritoEvento").modal('hide');
                        window.toastr.success('E-mail enviado com sucesso!')
                        props.inscritos()

                    }).catch((err) => {
                    
                        console.log(err.response)

                    })

                   

                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });



    }



    useEffect(() => {

        carrega()

    }, [emailGerado])

    

    useEffect(() => {
        
        setTexto('')
        carrega()
        //geraLinkRecuperacaoSenha()

    }, [inscricao_id, tipo])


    return (

        <div>

            <div className="modal fade" id="ModalEmailConfirmacao" tabindex="-1" role="dialog">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            <h1 className="modal-title">E-mail</h1>
                        </div>
                        <div class="modal-body">
                                
                                <div className="panel-body">
                                    
                                    
                                <div className="col-md-12">
                                        <div class="form-group">
                                            <label>E-mail</label>
                                            <input type="text" value={email} onChange={event => setEmail(event.target.value)} className="form-control" placeholder="" maxLength={500} />
                                                            
                                        </div>
                                    </div>

                                    <div className="col-md-12">
                                        <div class="form-group">
                                            <label>Título/Assunto</label>
                                            <input type="text" value={titulo} onChange={event => setTitulo(event.target.value)} className="form-control" placeholder="" maxLength={500} />
                                                            
                                        </div>
                                    </div>


                                    <div class="col-md-12">

                                        <div class="form-group">
                                            <label>Texto</label>
                                                    
                                            <JoditEditor 
                                                ref={editor}
                                                value={content}
                                                config={config}
                                                tabIndex={1} // tabIndex of textarea
                                                onBlur={newContent => setTexto(newContent)} // preferred to use only this option to update the content for performance reasons
                                                onChange={newContent => {}}
                                            />

                                                            
                                        </div>

                                    </div>


                                    

                                </div>


                        </div>
                        <div className="modal-footer">

                            <button type="button" className="btn btn-secondary" data-dismiss="modal">Fechar</button>
                            <button type="button" className="btn btn-success" onClick={() => enviaMail()}>Enviar e-mail</button>
                            
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )


}

export default Modal